<ui-grid [data]="data$ | async"
         [loading]="loading$ | async"
         [selectable]="false">
    <ui-grid-header [search]="true">
        <ui-header-button type="inline">
            <ng-template>
                <ui-grid-reset *ngIf="hasCustomFilters$ | async"
                               (reset)="resetFilter()"></ui-grid-reset>
            </ng-template>
        </ui-header-button>
        <ui-header-button type="main">
            <ng-template>

                <a [href]="reportsUrl$ | async"
                   [matTooltip]="'audit_grid_action_export' | translate"
                   [uiClickTrack]="'Action: Download Logs'"
                   (click)="downloadReport($event)"
                   mat-mini-fab
                   color="primary"
                   target="report">
                    <mat-icon>file_download</mat-icon>
                </a>
            </ng-template>
        </ui-header-button>
    </ui-grid-header>

    <ui-grid-column [primary]="true"
                    [title]="'audit_grid_component' | translate"
                    [width]="isHost ? '25%' : '15%'"
                    property="component">
        <ui-grid-dropdown-filter [items]="components">
        </ui-grid-dropdown-filter>
        <ng-template let-entry="data">
            <span *ngLet="('AuditComponent_' + entry.component | translate) as componentText"
                  [matTooltip]="componentText">
                {{componentText}}
            </span>
        </ng-template>
    </ui-grid-column>
    <ui-grid-column *ngIf="!isHost"
                    [sortable]="true"
                    [title]="'audit_grid_user' | translate"
                    property="userName"
                    width="10%">
        <ui-grid-search-filter [searchSourceFactory]="userSuggest"
                               [disabled]="!(isUsersViewGranted$ | async)"
                               property="userId">
        </ui-grid-search-filter>
        <ng-template let-entry="data">
            <span [class.strikethrough]="entry.userIsDeleted"
                  [title]="entry.userIsDeleted ? '' : entry.userName"
                  [matTooltip]="'audit_user_removed_tooltip' | translate"
                  [matTooltipDisabled]="!entry.userIsDeleted">
                {{ entry.userName }}
            </span>
        </ng-template>
    </ui-grid-column>
    <ui-grid-column [title]="'audit_grid_action' | translate"
                    property="action"
                    width="10%">
        <ui-grid-dropdown-filter [items]="actions">
        </ui-grid-dropdown-filter>
        <ng-template let-entry="data">
            <span *ngLet="('AuditAction_' + entry.action | translate) as actionText"
                  [matTooltip]="actionText">
                {{actionText}}
            </span>
        </ng-template>
    </ui-grid-column>
    <ui-grid-column [sortable]="false"
                    [primary]="true"
                    [title]="'audit_grid_operation' | translate"
                    width="50%"
                    property="operation">
    </ui-grid-column>
    <ui-grid-column [sortable]="true"
                    [title]="'audit_grid_time' | translate"
                    sort="desc"
                    property="time"
                    width="15%">
        <ui-grid-dropdown-filter [items]="intervals"
                                 [value]="intervalValueFor(Interval.Day)"
                                 method="ge">
        </ui-grid-dropdown-filter>
        <ng-template let-index="index"
                     let-entry="data">
            <ui-dateformat #timeFormat
                           [matTooltip]="timeFormat?.dataset['title']"
                           [date]="entry.time"
                           contentType="relative">
            </ui-dateformat>
        </ng-template>
    </ui-grid-column>
    <ui-grid-column [visible]="false"
                    [searchable]="true"
                    property="parameters">
    </ui-grid-column>
    <ui-grid-row-action>
        <ng-template let-index="index"
                     let-entry="data">
            <button *ngIf="entry.hasDetails"
                    [disabled]="loadingDetails$ | async"
                    [matTooltip]="'audit_grid_action_view_details' | translate"
                    [uiClickTrack]="'Action: Grid: View Details'"
                    (click)="showDetails(entry)"
                    mat-icon-button
                    data-cy="audit-action-menu"
                    type="button">
                <mat-icon svgIcon="uipath:info"></mat-icon>
            </button>
        </ng-template>
    </ui-grid-row-action>
    <ui-grid-footer [length]="total$ | async"
                    [pageSize]="pageSize"
                    [pageSizes]="pageSizes">
    </ui-grid-footer>
</ui-grid>
